import React, { useState, useEffect } from 'react';
import QueryList from './QueryList';
import QueryDetails from './QueryDetails'

import './QueryManagerMain.css';
import ResultQueryManager from './ResultQueryManager';

const QueryManagerMain = (props) => {
  const [queryLabelData, setQueryLabelData] = useState()
  const [selectedQuery, setSelectedQuery] = useState()

  useEffect(()=>{
    setQueryLabelData(props.queryLabelData)

  },[props.queryLabelData])

  useEffect(()=>{
    setSelectedQuery(props.selectedQuery)
  },[props.selectedQuery])

  return (
    <div className="row featured-main">
      <div id="manageQueryBoxLR">
        {queryLabelData &&
          <div id="manageQueryLeft">
            <QueryList handleExportBtn={props.handleExportBtn} handleAllDeselectBtn={props.handleAllDeselectBtn} handleAllSelectBtn={props.handleAllSelectBtn} handleCheckBox={props.handleCheckBox} handleClick={props.handleSelectedQuery} queryLabelData={queryLabelData}
              handleSearchBtn={props.handleSearchBtn} queryFilter={props.queryFilter} handleSearchInput={props.handleSearchInput} handleFilteredArray={props.handleFilteredArray} filteredArray={props.filteredArray}
            />
          </div>
        }
        {selectedQuery && 
          <div id="manageQueryRight">
            <QueryDetails queryInfo={selectedQuery} andString={props.andString} orString={props.orString} notString={props.notString} booleanQuery={props.booleanQuery}
              handleAndString={props.handleAndString} handleOrString={props.handleOrString} handleNotString={props.handleNotString} handleBooleanQuery={props.handleBooleanQuery}
              editable={props.editable} handleEditable={props.handleEditable} handleCancelBtn={props.handleCancelBtn} handleSaveBtn={props.handleSaveBtn}
              handleRemoveBtn={props.handleRemoveBtn} dateRange={props.dateRange} handleResultBtn={props.checkQueryResult}
              />
          </div>
        }
        <div id="queryResult">
          <div id="queryResultTab">
            <ResultQueryManager
              minDate={props.minDate}
              handleRefreshBtn={props.handleRefresh}
              handleDate={props.handleDate}
              dateRange={props.dateRange}
              resultData={props.resultData}
              handleRefresh={props.handleRefresh}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default QueryManagerMain;